// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiQuantity {
    'priced'?: string | null;
    'unitDescription'?: string | null;
    'unitOfMeasure'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiQuantity>> = [
        {
            "name":     "priced",
            "baseName": "priced",
            "type":     "string"
        },
        {
            "name":     "unitDescription",
            "baseName": "unitDescription",
            "type":     "string"
        },
        {
            "name":     "unitOfMeasure",
            "baseName": "unitOfMeasure",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiQuantity.attributeTypeMap;
    }
}
